module.exports = __webpack_public_path__ + "img/Niue.f58c75cb.svg";